'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/eval.js
// module id = 1223
// module chunks = 5